import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  Typography,
  Divider,
  Collapse,
  MenuItem,
} from "@mui/material";
import { MdLogout, MdSettings, MdPerson } from "react-icons/md";
import "./DrawerMenu.css";
import Logo from "../../assets/images/logo.png";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

const DrawerMenu = ({
  isOpen,
  onClose,
  userData,
  statusStyle,
  role,
  navLinks,
  showProfileDetails,
  toggleProfileDetails,
  handleLogout,
  isInQuizSession = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!isOpen) return null;

  return (
    <div className="drawer">
      {/* Overlay to click outside and close */}
      <div className="drawer-overlay" onClick={onClose}></div>

      {/* Drawer Content */}
      <div className="drawer-content">
        {/* Logo */}
        <img src={Logo} alt="EDUWaves logo" width={120} />

        {userData ? (
          <Box className="drawer-profile-card">
            <Avatar className="drawer-avatar">
              {userData?.name ? userData.name[0].toUpperCase() : <MdPerson />}
            </Avatar>
            <Typography
              variant="h6"
              className="drawer-profile-name capitalize-text"
            >
              {userData?.name || "Guest User"}
            </Typography>
            <Typography variant="body2" className="drawer-profile-email">
              {userData?.email || "No email"}
            </Typography>
            <span
              className="drawer-status-badge"
              style={{ backgroundColor: statusStyle.color }}
            >
              {statusStyle.text}
            </span>
          </Box>
        ) : (
          <>
            {/* Buttons for unauthenticated users */}
            <Link to="/auth" className="drawer-button" onClick={onClose}>
              Register for Free
            </Link>
            <Link
              to="/auth?skipRegistration=true"
              className="drawer-button drawer-button-login"
              onClick={onClose}
            >
              Login
            </Link>
          </>
        )}

        {/* Extra profile details (if expanded) */}
        <Collapse in={showProfileDetails}>
          <Box className="drawer-profile-details">
            <Typography variant="h6" className="drawer-role">
              {role?.charAt(0).toUpperCase() + role?.slice(1)}
            </Typography>
            <Typography
              className="drawer-status"
              style={{ color: statusStyle.color }}
            >
              {statusStyle.text}
            </Typography>
          </Box>
          <MenuItem className="menu-item" onClick={() => navigate("/profile")}>
            <ManageAccountsIcon className="menu-item-icon" />
            Profile
          </MenuItem>
        </Collapse>

        <Divider />

        {/* Home button (conditionally shown) */}
        {location.pathname !== "/dashboard" && location.pathname !== "/" && (
          <Link
            to="/dashboard"
            className={`drawer-link ${isInQuizSession ? "disabled" : ""}`}
            onClick={isInQuizSession ? (e) => e.preventDefault() : onClose}
            style={
              isInQuizSession ? { pointerEvents: "none", opacity: 0.5 } : {}
            }
          >
            Home
          </Link>
        )}

        {/* Dynamically render nav links */}
        {navLinks?.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`drawer-link ${isInQuizSession ? "disabled" : ""}`}
            onClick={isInQuizSession ? (e) => e.preventDefault() : onClose}
            style={
              isInQuizSession ? { pointerEvents: "none", opacity: 0.5 } : {}
            }
          >
            {link.icon && <link.icon className="drawer-icon" />}
            {link.label}
          </Link>
        ))}

        {/* Students Navigation Link for relevant roles */}
        {(role === "family" || role === "teacher" || role === "school") && (
          <Link
            to="/students"
            className={`drawer-link ${isInQuizSession ? "disabled" : ""}`}
            onClick={isInQuizSession ? (e) => e.preventDefault() : onClose}
            style={
              isInQuizSession ? { pointerEvents: "none", opacity: 0.5 } : {}
            }
          >
            Students
          </Link>
        )}

        {/* Logout option for authenticated users */}
        {userData && (
          <>
            <Divider />
            <MenuItem
              className={`drawer-link colored ${
                isInQuizSession ? "disabled" : ""
              }`}
              onClick={isInQuizSession ? undefined : () => navigate("/profile")}
              style={
                isInQuizSession ? { pointerEvents: "none", opacity: 0.5 } : {}
              }
            >
              <ManageAccountsIcon className="menu-item-icon" />
              Profile
            </MenuItem>
            <Link
              to="/logout"
              className={`drawer-link colored ${
                isInQuizSession ? "disabled" : ""
              }`}
              onClick={
                isInQuizSession ? (e) => e.preventDefault() : handleLogout
              }
              style={
                isInQuizSession ? { pointerEvents: "none", opacity: 0.5 } : {}
              }
            >
              <MdLogout className="drawer-icon" />
              Logout
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default DrawerMenu;
